'use client';

import { useGrowthBook } from '@growthbook/growthbook-react';

export { useGrowthBook };
